/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorAttributions
 */
export interface AuthorAttributions {
    /**
     * 
     * @type {string}
     * @memberof AuthorAttributions
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorAttributions
     */
    uri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthorAttributions
     */
    photoUri?: string | null;
}

/**
 * Check if a given object implements the AuthorAttributions interface.
 */
export function instanceOfAuthorAttributions(value: object): value is AuthorAttributions {
    return true;
}

export function AuthorAttributionsFromJSON(json: any): AuthorAttributions {
    return AuthorAttributionsFromJSONTyped(json, false);
}

export function AuthorAttributionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorAttributions {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'uri': json['uri'] == null ? undefined : json['uri'],
        'photoUri': json['photoUri'] == null ? undefined : json['photoUri'],
    };
}

export function AuthorAttributionsToJSON(json: any): AuthorAttributions {
    return AuthorAttributionsToJSONTyped(json, false);
}

export function AuthorAttributionsToJSONTyped(value?: AuthorAttributions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'uri': value['uri'],
        'photoUri': value['photoUri'],
    };
}

